import Clarity from '@microsoft/clarity';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import {useEffect} from  'react'
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Head({ title, description, keywords, ogImage, ogUrl, ogType = 'website', canonical, structuredData }) {
  const location = useLocation();
  const { clientData } = useSelector((state) => state.client || {});
  const siteName = clientData?.name || process.env.REACT_APP_NAME || 'Website Name';
  const defaultTitle = title || siteName;
  const defaultDescription =
    description || clientData?.description || process.env.REACT_APP_DESCRIPTION || 'Website description goes here';
  const defaultKeywords = keywords || process.env.REACT_APP_KEYWORDS || 'keyword1, keyword2, keyword3';
  const defaultOgImage = ogImage || clientData?.logo || process.env.REACT_APP_OG_IMAGE || '/logo.png';
  const currentUrl = ogUrl || `${window.location.origin}${location.pathname}`;
  const canonicalUrl = canonical || currentUrl;
  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;
    if (clarityId) {
      Clarity.init(clarityId);
    }
  }, []);
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{defaultTitle}</title>
        <meta name="description" content={defaultDescription} />
        <meta name="keywords" content={defaultKeywords} />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content={ogType} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content={defaultTitle} />
        <meta property="og:description" content={defaultDescription} />
        <meta property="og:image" content={defaultOgImage} />
        <meta property="og:site_name" content={siteName} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={currentUrl} />
        <meta property="twitter:title" content={defaultTitle} />
        <meta property="twitter:description" content={defaultDescription} />
        <meta property="twitter:image" content={defaultOgImage} />

        {/* Mobile Responsiveness */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Favicon */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />

        {/* Structured Data for SEO */}
        {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}

        {/* Verifikasi pemilik situs */}
        {clientData?.googleVerification && (
          <meta name="google-site-verification" content={clientData.googleVerification} />
        )}
      </Helmet>

    </>
  );
}

export default Head;
